import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseAddComponent } from '../base-add/base-add.component';
import { Product } from 'src/app/entities/product';
import { Category } from 'src/app/entities/category';
import { ProductService } from 'src/app/services/product.service';
import { CategoryService } from 'src/app/services/category.service';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MIATableModel } from '@mobileia/core';
import { ProductChild } from 'src/app/entities/product-child';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { GoogleStorageService } from 'src/app/services/google-storage.service';

@Component({
  selector: 'app-product-add',
  templateUrl: './product-add.component.html',
  styleUrls: ['./product-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class ProductAddComponent extends BaseAddComponent<Product> implements OnInit {

  pathUrlList = 'product';
  categories = new Array<Category>();

  constructor(
    protected productService: ProductService,
    protected categoryService: CategoryService,
    protected filesService: GoogleStorageService,
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) {
    super(alertService, route, navigator);
    this.service = productService;
    this.serviceGoogle = filesService;
    this.item = new Product();
    this.initFields();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadCategories();
  }

  initFields() {
    this.configFields = [
      {
        type: 'string',
        key: 'external_code',
        title: 'Código',
        caption: ''
      },
      {
        type: 'string',
        key: 'title',
        title: 'Titulo',
        caption: ''
      },
      {
        type: 'file',
        key: 'photo_feature',
        fileType: 'path',
        title: 'Imagen Principal',
        caption: ''
      },
      {
        type: 'select',
        key: 'category_id',
        title: 'Categoría',
        caption: '',
        options: []
      },
      {
        type: 'price',
        key: 'price',
        title: 'Precio Venta',
        caption: ''
      },
      {
        type: 'price_two',
        key: 'price_two',
        title: 'Precio Lista',
        caption: ''
      },
      {
        type: 'stock',
        key: 'stock',
        title: 'Stock',
        caption: ''
      },
      {
        type: 'text',
        key: 'caption',
        title: 'Descripción',
        caption: ''
      },
      {
        type: 'string',
        key: 'caption_short',
        title: 'Descripción corta',
        caption: ''
      },
      {
        type: 'select',
        key: 'is_feature',
        title: '¿Destacado?',
        caption: '',
        options: [
          {
            title: 'SI',
            value: 1
          },
          {
            title: 'NO',
            value: 0
          }
        ]
      },
      {
        type: 'gallery',
        key: 'photos',
        title: 'Fotos / Galería',
        caption: ''
      },
      {
        type: 'string',
        key: 'video',
        title: 'YouTube Video',
        caption: 'URL de ejemplo: https://www.youtube.com/embed/xeiytBHedQI'
      },
      {
        type: 'select',
        key: 'status',
        title: 'Visible',
        caption: '',
        options: [
          {
            title: 'Activado',
            value: 1
          },
          {
            title: 'Desactivado',
            value: 0
          }
        ]
      },
    ];
  }

  processCategories() {
    let options = [];
    for (const parent of this.categories) {
      options.push({
        title: parent.title,
        value: parent.id
      });
    }
    this.configFields[2].options = options;
  }

  loadCategories() {
    this.categoryService.fetchAll().toPromise().then(data => {
      if (!data.success) {
        return;
      }
      this.categories = data.response.data;
      this.processCategories();
    });
  }

  configIfNew() {
    this.item.childs.push(new ProductChild());
  }
}
